import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

import {apiCall, hideLoader, showLoader} from '../../utils';

import {Project} from '@bumpy/i18n_common';

type Props = {
  project: Project;
  onClose: () => void;
};

export const NewRevisionDialog: React.FC<Props> = ({project, onClose}) => {
  const [name, setName] = React.useState<string>('');
  const [branch, setBranch] = React.useState<string>('');
  const [validationBranch, setValidationBranch] =
    React.useState<string>('main');

  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">New revision</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Enter revision name
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          margin="none"
          variant="standard"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        {project?.git && (
          <>
            <DialogContentText id="alert-dialog-description">
              {'Enter branch name'}
            </DialogContentText>
            <TextField
              autoFocus
              fullWidth
              margin="none"
              variant="standard"
              value={branch}
              onChange={(e) => {
                setBranch(e.target.value);
              }}
            />
            {project.validationSetupProjectScript && (
              <>
                <DialogContentText id="alert-dialog-description">
                  Enter validation branch name
                </DialogContentText>
                <TextField
                  autoFocus
                  fullWidth
                  margin="none"
                  variant="standard"
                  value={validationBranch}
                  onChange={(e) => {
                    setValidationBranch(e.target.value);
                  }}
                />
              </>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            //
            showLoader('Creating revision');
            apiCall({
              method: 'POST',
              url: `/projects/${project.uuid}/revisions`,
              data: {name, branch, validationBranch},
              secure: true,
            })
              .then(onClose)
              .finally(hideLoader);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
